import {useEffect, useState} from "react";
import {getAll as getRecords} from "app/requests/admin/categories";
import Links from "components/pages/admin/cases/list/links";
import Loading from "components/pages/loading";
import Row from "./row";

export default function AdminCategoriesList() {
  const [records, setRecords] = useState(null);
  const onDestroy = (id) => {
    setRecords(records.filter((record) => record.id !== id));
  };

  useEffect(() => {
    getRecords().then((data) => setRecords(data.categories));
  }, []);

  if(!records) { return <Loading />; }

  return (
    <div className="max-w-screen-lg mx-auto">
      <h1 className="text-center">Categories</h1>
      <div className="flex justify-between mb-1">
        <Links />
        <a className="btn btn-outline-black btn-sm" href="/admin/categories/new">New Category</a>
      </div>
      <div className="table-responsive">
        <table className="table text-center">
          <thead>
            <tr>
              <th>Name</th>
              <th>Display</th>
              <th>Layout</th>
              <th>Created At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {records.map((record) => (
              <Row key={record.id} onDestroy={onDestroy} record={record} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
